<style>
#scadaChartModal .v--modal-box.v--modal {
  min-width: 620px !important;
  min-height: 320px !important;
}
#scadaChartModal .modal__content {
  overflow-y: auto !important;
}
#scadaChartModal .v-tabs__container {
  justify-content: center;
}
#scadaChartModal .list__container--header {
  background: #2a579a;
  color: #ffffff;
  text-align: center;
  border-right: 1px solid lightgrey;
  border-left: 1px solid lightgrey;
}
#scadaChartModal .list__container--el {
  justify-content: center;
}
#scadaChartModal .daterangepicker {
  outline: 1px solid lightgray;
  margin-bottom: 20px;
}
#scadaChartModal .card-container {
  width: 100%;
  text-align: center;
}
</style>

<template>
  <Modal
    modalName="scadaChartModal"
    @opened="createChart"
    @export="exportToCsv"
    title="Przebieg zmian odczytów"
    :buttons="['export']"
  >
    <div>
      <label>Wybierz zakres dat</label>
      <input
        type="datetime-local"
        id="start-time"
        class="daterangepicker"
        placeholder="Start"
        name="start-time"
        v-model="startTime"
      >
      <input
        type="datetime-local"
        id="end-time"
        class="daterangepicker"
        placeholder="Koniec"
        name="end-time"
        v-model="endTime"
      >
      <v-btn @click="updateRange" class="font--primary" dark depressed color="#2a579a">Pokaż zakres</v-btn>

      <v-tabs color="white" slider-color="white">
        <v-tab :key="1" ripple>Wykres</v-tab>
        <v-tab-item>
          <div class="card-container">
            <v-progress-circular
              v-if="isLoading"
              indeterminate
              color="primary"
              class="text-xs-center"
            ></v-progress-circular>
            <canvas v-show="!isLoading" id="myChart"></canvas>
          </div>
        </v-tab-item>

        <v-tab :key="2" ripple>Dane</v-tab>
        <v-tab-item>
          <ul class="values__list" style="list-style-type:none; padding-left: 0px;">
            <v-layout>
              <v-flex xs6>
                <li class="list__container--header">Czas</li>
                <li
                  style="border-right: 1px solid lightgrey;border-left: 1px solid lightgrey;"
                  class="list__container--el"
                  v-for="(item, index) in chartLabels"
                  :key="index"
                >{{item}}</li>
              </v-flex>
              <v-flex xs6>
                <li class="list__container--header">{{chartName}} {{chartUnit}}</li>
                <li
                  style="border-right: 1px solid lightgrey;"
                  class="list__container--el"
                  v-for="(item, index) in chartData"
                  :key="index"
                >{{item}}</li>
              </v-flex>
            </v-layout>
          </ul>
        </v-tab-item>
      </v-tabs>
    </div>
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";
import Chart from "chart.js";

export default {
  components: {
    Modal
  },
  data() {
    return {
      chartData: [],
      chartLabels: [],
      measuringSerieID: undefined,
      chartUnit: undefined,
      chartName: undefined,
      startTime: undefined,
      endTime: undefined,
      myLineChart: undefined,
      isLoading: false
    };
  },
  mounted() {
    this.$root.$on("passUnit", this.generateData);
  },
  methods: {
    generateData(data) {
      this.chartData = [];
      this.chartLabels = [];
      this.chartUnit = undefined;
      this.chartName = undefined;

      this.chartUnit = data[0].unit;
      this.chartName = data[1];
      this.measuringSerieID = data[2];
      for (let el of data[0].data) {
        this.chartData.push(el.value.toFixed(2));
        this.chartLabels.push(el.time);
      }
    },
    updateRange() {
      this.isLoading = true;
      const self = this;
      self.chartData = [];
      self.chartLabels = [];

      let payload = {
        oid: this.measuringSerieID,
        from: Date.parse(this.startTime) / 1000,
        to: Date.parse(this.endTime) / 1000
      };
      this.$store.dispatch("getMeasuresRange", payload).then(res => {
        for (let el of res.data) {
          self.chartData.push(el.value.toFixed(2));
          self.chartLabels.push(el.time);
        }

        self.myLineChart.destroy();
        self.drawChart(
          self.chartLabels,
          self.chartData,
          self.chartName,
          self.chartUnit
        );
        self.isLoading = false;
      });
    },
    createChart() {
      const self = this;
      let currentDatetime = new Date();
      let yesterday = new Date();
      self.endTime = currentDatetime.toISOString().substring(0, 16);
      yesterday.setDate(currentDatetime.getDate() - 1);
      self.startTime = yesterday.toISOString().substring(0, 16);

      self.drawChart(
        self.chartLabels,
        self.chartData,
        self.chartName,
        self.chartUnit
      );
    },
    drawChart(labels, data, name, unit) {
      const ctx = document.getElementById("myChart").getContext("2d");
      this.myLineChart = new Chart(ctx, {
        type: "line",
        data: {
          labels: labels,
          datasets: [
            {
              label: `${name} ${unit}`,
              backgroundColor: "rgba(0,0,0,0)",
              borderColor: "rgb(255, 99, 132)",
              data: data
            }
          ]
        },
        options: {
          scales: {
            xAxes: [
              {
                ticks: {
                  autoSkip: true,
                  maxTicksLimit: 20,
                  maxRotation: 90,
                  minRotation: 90
                }
              }
            ]
          }
        }
      });
    },
    exportToCsv() {
      let csv = "Czas, Dane\n";

      for (let i in this.chartData) {
        csv += this.chartLabels[i] + "," + this.chartData[i];
        csv += "\n";
      }
      const hiddenElement = document.createElement("a");
      hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
      hiddenElement.target = "_blank";
      hiddenElement.download = "dane.csv";
      hiddenElement.click();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/scada/modals/ScadaChart.vue